export const getChildDetails = (state) =>
	state.rootReducer.parentDetails.childrenList;

export const getActiveChild = (state) =>
	state.rootReducer.parentDetails.activeChildId;

export const getChildToken = (state) =>
	state.rootReducer.parentDetails.childToken;
